<template>
<svg class="cnm-icon" width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="10.5" y="11.3667" width="27" height="5.14286" fill="black"/>
<rect x="10.5" y="18.6545" width="27" height="5.14286" fill="black"/>
<rect x="10.5" y="25.9424" width="27" height="5.14286" fill="black"/>
<rect x="10.5" y="33.2302" width="27" height="5.14286" fill="black"/>
</svg>
</template>